import { render, staticRenderFns } from "./CatalogProductTable.vue?vue&type=template&id=73ce52c2&scoped=true&"
import script from "./CatalogProductTable.vue?vue&type=script&lang=js&"
export * from "./CatalogProductTable.vue?vue&type=script&lang=js&"
import style0 from "./CatalogProductTable.vue?vue&type=style&index=0&id=73ce52c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ce52c2",
  null
  
)

export default component.exports